export default SoundPlayer;

import { SpeakerXMarkIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { useState } from 'react';

import { useClickAnyWhere } from '@/renderer/utils/hooks/useClickAnyWhere';
import { useEventListener } from '@/renderer/utils/hooks/useEventListener';

export function SoundPlayer({ text = 'Enable sounds', startVisible = false, small = false }) {
  const [show, setShow] = useState(0); // useState(IS_SERVER ? true : !navigator.userActivation?.isActive);

  useClickAnyWhere(() => {
    setShow(2); // dont show it ever again
  });

  useEventListener('rasplayerror', () => {
    const platform = `${
      typeof navigator !== 'undefined' && (navigator.userAgentData?.platform || navigator.platform)
    }`;

    const isIosOrAndroid = platform.startsWith('i') || platform.toLowerCase().includes('android');

    // Don't show this on mobile; sometimes they can't play sound at all
    if (!isIosOrAndroid) {
      setShow((oldShow) => {
        return oldShow === 0 ? 1 : oldShow;
      });
    }
  });

  return (
    <>
      {show === 1 && (
        <button
          className={clsx(
            'group relative mx-auto flex flex-row rounded-sm bg-zinc-800 p-2 text-left hover:bg-zinc-700',
            small ? 'space-x-1 self-center px-2 py-1' : 'space-x-2 p-2',
          )}
          title="Enable sounds"
        >
          <SpeakerXMarkIcon
            className={clsx('w-auto text-red-400', small ? 'h-4' : 'h-5')}
            aria-hidden="true"
          />
          <span
            className={clsx(
              'max-w-fit overflow-hidden whitespace-nowrap rounded-sm text-xs text-zinc-200 transition-[width,opacity]',
              startVisible
                ? 'w-auto self-center'
                : 'pointer-events-none absolute top-0 z-1 w-0 bg-zinc-800 px-2 opacity-0 group-hover:w-[99rem] group-hover:bg-zinc-700 group-hover:opacity-100',
              small ? 'left-5 h-6 leading-6' : 'left-5 h-9 leading-9',
            )}
          >
            {text}
          </span>
        </button>
      )}
    </>
  );
}
